import dynamic from 'next/dynamic'

export const DynamicSearchFilterModal = dynamic(
  () => import('.').then((mod) => mod.SearchFilterModal),
  { ssr: false },
)
